module.exports = __webpack_public_path__ + "media/images/error/500-fb8b85ed74a3d19abe231ddf95d6ff28.png";